// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()				;
require("@rails/activestorage").start()		;
require("channels")							;

window.bootstrap = require("bootstrap")		;
require('webpack-jquery-ui')				;
require('webpack-jquery-ui/css')			;

require("@fortawesome/fontawesome-free/css/all")		;
require('bootstrap-icons/font/bootstrap-icons.css')		;

window.Cropper = require("cropperjs");
require('cropperjs/dist/cropper.css');
require('jquery-cropper/dist/jquery-cropper');
require('dropzone/dist/dropzone');
require('dropzone/dist/dropzone.css');


require('packs/test');
require('packs/crop_image');
require('packs/servie_vehicle_track');
require('packs/default');
require('packs/jobcard');
require('packs/out_message');
require('packs/vehicle_registeration');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

$( function() {
		$( ".datepicker").datepicker();
} );

$(function(){
    $(".size_500").change(function(){
        file_size = this.files[0].size;
        if(file_size > 500000){
        	alert("MAX FILE SIZE ALLOWED IS 500KB");
        	$(this).val('');        	
        }
    });
});
